
const Boja = function(DS) {

    return DS.defineResource({
        name: 'Boja',
        endpoint: '/boje',
    });
};

Boja.$inject = ['DS'];


export {Boja};



// WEBPACK FOOTER //
// ./app/models/boja.js